import React from "react";
import { byCodes, getPostNum } from "../../../constant/General";
import ContentWrapper from "./ContentWrapper";
import Loading from "../../results/loading";
import Random from "../../results/random";


const ResultTCDay = ({ result, config, image }) => {
    const { results, rightResults } = result;
    let posts = byCodes(rightResults, ["F", "A", "B", "C", "D"]);

    return <ContentWrapper image={image} type={config.type} shift="day">
        <div className="d-flex justify-content-end w-50">
            <table className="tc overflow-hidden">
                <tbody>
                    {results.map((res, j) => {
                        const hlBG = config.hlIndex.includes(j);
                        const style = {
                            background: hlBG ? config.hlBG : config.background
                        }
                        return <tr style={style} className={`row-${j}`} key={j}>
                            {res.items.map((list, i) => {
                                const style = config.row[`row_${j}`]
                                return <td align="middle" key={`${j}_${i}`}>
                                    {list.map((num, index) => {
                                        if (num.includes("*")) {
                                            return <div key={index}>
                                                <Loading style={style?.loading ?? config?.loading}
                                                    className="loading-res"
                                                    sizeDigit={num.length} />
                                            </div>
                                        }
                                        if (num.includes("?")) {
                                            let randomSt = style?.random ? {
                                                ...style.random,
                                                background: config.random.background
                                            } : config.random
                                            return <div key={index}>
                                                <Random className="random-res" style={randomSt} sizeDigit={num.length} />
                                            </div>
                                        }
                                        return <div style={{ ...style?.normal }}
                                            key={index}>{num}</div>
                                    })}
                                </td>
                            })}
                        </tr>
                    })}
                </tbody>
            </table>
        </div>

        <div className="w-50 overflow-hidden d-flex justify-content-center align-items-center">
            <div style={{
                padding: "10px"
            }} className="w-100 h-100">
                <div style={{
                    fontSize: "110px",
                    marginLeft: "245px",
                }} className="post w-100">
                    {posts.map((post, i) => {
                        return <div
                            style={{
                                height: "110px", marginBottom: "21px"
                            }}
                            className="d-flex" key={i}>
                            <div style={{
                                marginRight: "100px", width: "130px"
                            }}>{getPostNum(post.twoD)}</div>
                            <div>{getPostNum(post.threeD)}</div>
                        </div>
                    })}
                </div>
            </div>
        </div>
    </ContentWrapper>
}

export default ResultTCDay;